<Modal
  title="Resend offer"
  actionTitle="Send"
  {isLoading}
  on:close={() => ($uiState.activeModal = undefined)}
  on:action={() => apply()}>

  <div class="block">
    This offer was sent to charities within the original offer radius of <b>{item.data.options.distance || 20 } miles</b>.
  </div>

  <div class="field">
    <div class="control">
      <label class="radio">
        <input type="radio" name="option" bind:group={option} value="default">
        Resend to original radius
      </label>
      <br>
      <label class="radio">
        <input type="radio" name="option" bind:group={option} value="extended">
        Send to extended radius
      </label>
      <br>
      <label class="radio">
        <input type="radio" name="option" bind:group={option} value="default_extended">
        Resend to original radius <i>and</i> send to extended radius
      </label>
    </div>
  </div>

  {#if option != "default"}
  <div class="field">
    <label for="distance" class="label">Extended radius</label>
    <div class="control">
      <div class="select">
        <select bind:value={extendedDistance} name="distance">
          <option value={1}>1 mile</option>
          <option value={2}>2 miles</option>
          <option value={3}>3 miles</option>
          <option value={5}>5 miles</option>
          <option value={10}>10 miles</option>
          <option value={15}>15 miles</option>
          <option value={20}>20 miles</option>
          <option value={25}>25 miles</option>
          <option value={30}>30 miles</option>
          <option value={35}>35 miles</option>
          <option value={40}>40 miles</option>
          <option value={50}>50 miles</option>
          <option value={100}>100 miles</option>
        </select>
      </div>
    </div>
  </div>
  {/if}

  {#if errorMessage}
    <div class="notification is-danger is-light">{errorMessage}</div>
  {/if}
</Modal>

<script lang="ts">
  export let item : Offer_v2_Doc;

  import { logging } from '../../../../../lib/logging';
  import { uiState } from "../../../../../lib/uiState";
  import Modal from "../../../../_components/Modal.svelte";
  import ConfirmSent from "./ConfirmSent.svelte";

  let errorMessage : string;
  let isLoading = false;

  let option = 'default';
  let extendedDistance = 25;

  async function apply() {
    let firebase = window.firebase;

    const originalDistance = (item.data.options.distance || 20);

    const minDistance = (option == 'extended') ? originalDistance : 0;
    const maxDistance = (option == 'default') ? originalDistance : extendedDistance;

    isLoading = true;

    await firebase
      .functions()
      .httpsCallable('admin-sendnotifications')({ offerId: item.id, minDistance, maxDistance })
      .catch((err) => {
        logging.report(err.toString());
        errorMessage = err;
      })
      .finally(() => (isLoading = false));

    $uiState.activeModal = { component: ConfirmSent };
  }
</script>
